import styled from 'styled-components'

const Thumbnail = styled.img`
    height: 57px;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.06), 0px 4px 6px -1px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
`

export default Thumbnail